<template>
  <ItemRow
    v-bind="$attrs"
    aria-label="Click to view certificate details"
    class="PkiCertificatesRow"
    tabindex="0"
    v-on="$listeners"
    @click.native="viewCertDetails"
    @keypress.prevent.native="handleItemKeypress"
  >
    <ItemWithLabel
      v-for="(column, idx) in columns"
      :key="idx"
      :column="column"
      :data-test-id="`PkiCertificateItemRow__${column.dataFieldName}`"
    >
      <PkiCertStatusBadge
        v-if="column.dataFieldName === 'status'"
        :status="itemData[column.dataFieldName]"
      />
      <Icon
        v-else-if="column.dataFieldName === 'icon'"
        class="PkiCertificatesRow__icon"
        icon="chevronRight"
        role="presentation"
      />
      <template v-else>
        {{ column.getValue ? column.getValue(itemData) : itemData[column.dataFieldName] }}
      </template>
    </ItemWithLabel>
  </ItemRow>
</template>

<script>
import {
  Icon,
  ItemRow,
  ItemWithLabel,
} from '@jumpcloud/ui-components';

import PkiCertStatusBadge from 'client/Pki/components/PkiCertStatusBadge.vue';

export default {
  name: 'PkiCertificatesRow',

  components: {
    Icon,
    ItemRow,
    ItemWithLabel,
    PkiCertStatusBadge,
  },

  props: {
    columns: {
      type: Array,
      required: true,
    },
    itemData: {
      type: Object,
      required: true,
    },
  },

  methods: {
    handleItemKeypress(e) {
      // Enter or Space
      if ([13, 32].includes(e.keyCode)) {
        this.viewCertDetails(e);
      }
    },

    viewCertDetails(e) {
      if (e.target.getAttribute('type') !== 'checkbox') {
        this.$router.push({
          name: 'Certificate Details',
          params: { id: this.itemData._id },
        });
      }
    },
  },
};
</script>

<style scoped>
.PkiCertificatesRow {
  cursor: pointer;
  position: relative;
  transition: background-color var(--jc-transition-duration);
  white-space: nowrap;
}

.PkiCertificatesRow:hover,
.PkiCertificatesRow:focus {
  background-color: var(--jc-background-tertiary-light);
}

.PkiCertificatesRow__icon {
  align-self: center;
}
</style>
